import { Common } from '@icc/shared/helpers';
import { Injectable } from '@angular/core';
import { IccWindowColors } from '@icc/construction-elements/types';

@Injectable({
    providedIn: 'root'
})
export class ColorsDefaultsService {

    /**
     * Zwraca rodzaj koloru ustawionego po danej stronie konstrukcji.
     */
    getColorValue(colors: IccWindowColors, side: 'outer' | 'inner', onlyFrame = false): 'NONE' | 'WHITE' | 'CREAM' | 'COLOR' | 'BICOLOR' {
        let value: 'NONE' | 'WHITE' | 'CREAM' | 'COLOR' | 'BICOLOR' = 'NONE';
        if (colors.frame && colors.frame[side] && (onlyFrame || colors.sash && colors.sash[side])) {
            if (colors.frame[side].type === 'white' && (onlyFrame || colors.sash[side].type === 'white')) {
                value = 'WHITE';
            } else if (colors.frame[side].type === 'cream' && (onlyFrame || colors.sash[side].type === 'cream')) {
                value = 'CREAM';
            } else if (
                Common.isDefined(colors.frame[side].id)
                && colors.frame[side].type !== 'white'
                && colors.frame[side].type !== 'cream'
                && (onlyFrame ||
                    Common.isDefined(colors.sash[side].id)
                    && colors.sash[side].type !== 'white'
                    && colors.sash[side].type !== 'cream'
                    && colors.frame[side].id === colors.sash[side].id
                )
            ) {
                value = 'COLOR';
            } else if (
                Common.isDefined(colors.frame[side].id)
                || (!onlyFrame && Common.isDefined(colors.sash[side].id))
            ) {
                value = 'BICOLOR';
            }
        }
        return value;
    }

    /**
     * Ustawia układ kolorów na podstawie ustawionych kolorów, jeśli wybrany nie pasuje.
     * @private
     * @param  {Object} colors      Kolory
     * @param  {Cbject} sashesCount Count skrzydeł
     * @return {Array}              Pary
     */
    getColorPairs(colors: IccWindowColors, type: 'sash' | 'frame' = 'frame') {
        let pairs = [];

        if (colors[type].outer?.type === 'white'
            && colors[type].inner?.type === 'white') {
            pairs = ['b_b'];
            this.buildCoreColor(colors, pairs, type);
        } else if (colors[type].outer?.type === 'cream'
            && colors[type].inner?.type === 'cream') {
            pairs = ['c_c'];
            this.buildCoreColor(colors, pairs, type);
        } else if (colors[type].outer?.id && colors[type].inner?.type === 'white') {
            if (Common.isArray(colors[type].outer.groups)) {
                for (let i = 0; i < colors[type].outer.groups.length; i++) {
                    if (pairs.indexOf(colors[type].outer.groups[i] + '_b')) {
                        pairs.push(colors[type].outer.groups[i] + '_b');
                    }
                }
            }
        } else if (colors[type].outer?.type === 'white' && colors[type].inner?.id) {
            if (Common.isArray(colors[type].inner.groups)) {
                for (let i = 0; i < colors[type].inner.groups.length; i++) {
                    if (pairs.indexOf('b_' + colors[type].inner.groups[i])) {
                        pairs.push('b_' + colors[type].inner.groups[i]);
                    }
                }
            }
        } else if (colors[type].outer?.id && colors[type].inner?.type === 'cream') {
            if (Common.isArray(colors[type].outer.groups)) {
                for (let i = 0; i < colors[type].outer.groups.length; i++) {
                    if (pairs.indexOf(colors[type].outer.groups[i] + '_c')) {
                        pairs.push(colors[type].outer.groups[i] + '_c');
                    }
                }
            }
        } else if (colors[type].outer?.type === 'cream' && colors[type].inner?.id) {
            if (Common.isArray(colors[type].inner.groups)) {
                for (let i = 0; i < colors[type].inner.groups.length; i++) {
                    if (pairs.indexOf('c_' + colors[type].inner.groups[i])) {
                        pairs.push('c_' + colors[type].inner.groups[i]);
                    }
                }
            }
        } else if (colors[type].outer?.id && colors[type].inner?.id && colors[type].outer?.id === colors[type].inner?.id) {
            this.buildBilateralAndBicolor(colors, pairs, { Bilateral: '_' }, type);
        } else if (colors[type].outer?.id && colors[type].inner?.id && colors[type].outer?.id !== colors[type].inner?.id) {
            this.buildBilateralAndBicolor(colors, pairs, { Bicolor: '__' }, type);
        }

        return pairs;
    }

    buildCoreColor(colors: IccWindowColors, pairs, type: 'sash' | 'frame' = 'frame') {
        if (Common.isArray(colors[type].core?.colorGroups)) {
            for (let i = 0; i < colors[type].core.colorGroups.length; i++) {
                if (
                    pairs.indexOf(
                        colors[type].core.colorGroups[i] + '_' + colors[type].core.colorGroups[i]
                    )
                ) {
                    pairs.push(
                        colors[type].core.colorGroups[i] + '_' + colors[type].core.colorGroups[i]
                    );
                }
            }
        }
    }

    buildBilateralAndBicolor(colors, pairs, colorSymbol, type: 'sash' | 'frame' = 'frame') {
        let symbol = null;
        if (colorSymbol.Bilateral) {
            symbol = '_';
        } else if (colorSymbol.Bicolor) {
            symbol = '__';
        }
        if (
            Common.isArray(colors[type].outer.groups)
            && Common.isArray(colors[type].inner.groups)
        ) {
            for (let i = 0; i < colors[type].outer.groups.length; i++) {
                for (let j = 0; j < colors[type].inner.groups.length; j++) {
                    if (
                        pairs.indexOf(
                            colors[type].outer.groups[i]
                                + symbol
                                + colors[type].inner.groups[j]
                        ) === -1
                    ) {
                        pairs.push(
                            colors[type].outer.groups[i]
                                + symbol
                                + colors[type].inner.groups[j]
                        );
                    }
                }
            }
        }
    }
}
